var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseBig(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M2.113.71l.094.083L7.5 6.085 12.793.793c.39-.39 1.024-.39 1.414 0 .36.36.388.928.083 1.32l-.083.094L8.915 7.5l5.292 5.293c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083L7.5 8.915l-5.293 5.292c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094L6.085 7.5.793 2.207c-.39-.39-.39-1.024 0-1.414.36-.36.928-.388 1.32-.083z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBig);
export default __webpack_public_path__ + "static/media/close-big.2b89052a.svg";
export { ForwardRef as ReactComponent };